import { Component, OnInit, DoCheck } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { CommonService } from '../_service/common.service';
import { help, online, helplink, supplierMailLink, helpLinkProspectNoIpn } from '../app.config';
import { AuthorizationService } from '../authorization.service';

@Component({
    selector: 'app-helpsection',
    templateUrl: './helpsection.component.html',
    styleUrls: ['./helpsection.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule
    ]
})
export class HelpsectionComponent implements OnInit, DoCheck {

  SupplierCheck: boolean = false;
  HelpLink = "";
  MailtoId = "";
  ccMailId = "";
  EmailuserIPN = "";
  EmailSubject = "";
  userIpn="";
  helpLink=helplink;
  public HAPPI_CLIENT_ID:any="";
  public HAPPI_CLIENT_SECRET:any="";
  public HAPPI_USERNAME:any="";
  public HAPPI_PASSWORD:any="";
  public HAPPI_API_KEY:any="";
  public HAPPI_URL:any="";
  public user=this.commonService.fromApp_UserName;
  public userIPN=this.commonService.fromApp_UserIPN;
  public userIsSupplier="";

  iconVisible: boolean;
  showRoleDropdown: boolean=false;
  superAdmin: boolean=false;
  admin: boolean = false;
  noIpnSupplier: boolean;
  

  constructor(private commonService: CommonService,public authservice:AuthorizationService) { }

  ngOnInit() {
    this.commonService.getHappi().subscribe((happiData : any) => {

      this.HAPPI_CLIENT_ID = happiData.HAPPI_CLIENT_ID;
      this.HAPPI_CLIENT_SECRET = happiData.HAPPI_CLIENT_SECRET;
      this.HAPPI_USERNAME   = happiData.HAPPI_USERNAME;
      this.HAPPI_PASSWORD   = happiData.HAPPI_PASSWORD;
      this.HAPPI_API_KEY    = happiData.HAPPI_API_KEY;
      this.HAPPI_URL        = happiData.Url;
    });
    this.noIpnSupplier = this.commonService.noIpnSupplier;
  }
  logout(){
let token=localStorage.getItem('IDPIdToken');

localStorage.setItem("IDPAccessToken", null);
localStorage.setItem("IDPIdToken",null);
localStorage.setItem("IDPexpiredtime", JSON.stringify(0));
localStorage.setItem("IDPexpiredMinutes", JSON.stringify(0));
localStorage.setItem("loginit", 'loggedOut');
    this.authservice.logoutSession(token);

  }
  ngDoCheck() { 
    this.getRoles();
  }

  openLink() {
    window.open(supplierMailLink)
  }

  getRoles() {
    this.noIpnSupplier = this.commonService.noIpnSupplier;
    let RoleByService = this.commonService.splitAndRolesAssign();
    this.checkAllProfilesAndEnv(RoleByService);
  }

  checkAllProfilesAndEnv(RoleByService){
    let c = RoleByService;
    if(c['userAccess']!=undefined && !c['userAccess'].includes('Deined')) {
      let roles=c['role']
      for(let i = 0 ; i < roles.length ; i++){
        roles[i] = roles[i].charAt(0).toUpperCase() + roles[i].substr(1);
    }       
      this.userIsSupplier= `(${roles.toString()})`;

      this.ccMailId = c['userEmail'];
      this.EmailuserIPN = c['userIpn'].toUpperCase();
      this.userIpn = c['userIpn'];
      this.EmailSubject = `ISA \u2013 ${this.EmailuserIPN} - `;
      if(c['superAdmin'] == 'yes'){
        this.superAdmin = true;
      }else{
        this.superAdmin = false;
      }if(c['role'][0].toLowerCase() == 'admin'){
        this.admin = true;
      }else{
        this.admin = false;
      }
      if(c['role'][0].toLowerCase() == 'supplier'){
        this.SupplierCheck = true;
        this.HelpLink = this.noIpnSupplier ? helpLinkProspectNoIpn : online;
        this.admin = false;
        this.superAdmin = false;
        this.MailtoId = "isa@renault.com";
      }else{
        this.SupplierCheck = false;
        this.HelpLink = help
        this.MailtoId = "mypurchasingpad_support@renault.com";
      }
    }
  }
  toggleRoleDropdown(event: Event): void{
    event.stopPropagation();
    this.showRoleDropdown = !this.showRoleDropdown;
  }
  switchRole(role: string) {
    this.commonService.setRole(role);
    this.showRoleDropdown = false;
    this.getRoles();
  }
}
